import _extends from "@babel/runtime-corejs3/helpers/extends";
import _ListDownIcon from "@sk/icons/lib/ListDownIcon";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';
import { ConfigConsumer } from '../../ConfigProvider';
import zhCN from '../../ConfigProvider/locale/zh';
import Input from '../../Input';
import { CloseIcon, CheckIcon } from '../../../icons';
import './style.scss';
var CustomSelect = /*#__PURE__*/React.memo(props => {
  var dataSource = props.dataSource,
    onSave = props.onSave,
    locale = props.locale,
    enableCustom = props.enableCustom,
    fuzzyQuery = props.fuzzyQuery,
    onQuery = props.onQuery,
    value = props.value,
    _props$flip = props.flip,
    flip = _props$flip === void 0 ? false : _props$flip,
    queryEmptyPlaceHolder = props.queryEmptyPlaceHolder,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 4 : _props$padding;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpen = _React$useState4[0],
    setIsOpen = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    position = _React$useState6[0],
    setPosition = _React$useState6[1];
  var _React$useState7 = React.useState([]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    rect = _React$useState8[0],
    setrect = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    rflip = _React$useState10[0],
    setrflip = _React$useState10[1];
  var filteredOptions = React.useMemo(() => {
    if (fuzzyQuery && inputValue !== null && inputValue !== void 0 && inputValue.length) {
      if (onQuery && onQuery instanceof Function) {
        return onQuery(dataSource, inputValue);
      }

      // Default: 不区分大小写 + 去掉前后空格
      var ndata = _filterInstanceProperty(dataSource).call(dataSource, val => {
        var _val$value, _context;
        return (_val$value = val.value) === null || _val$value === void 0 ? void 0 : _includesInstanceProperty(_context = _val$value.toLowerCase()).call(_context, _trimInstanceProperty(inputValue).call(inputValue).toLowerCase());
      });
      if (rflip) {
        var len = enableCustom ? (ndata.length + 1) * 36 : ndata.length * 36;
        var dropdownHeight = Math.min(len, enableCustom ? 260 : 224);
        if (ndata.length === 0 && queryEmptyPlaceHolder) {
          dropdownHeight = 72;
        }
        var py = rect[1] - dropdownHeight - padding;
        setPosition([rect[0], py]);
      }
      return ndata;
    }
    if (rflip) {
      var _len = enableCustom ? (dataSource.length + 1) * 36 : dataSource.length * 36;
      var _dropdownHeight = Math.min(_len, enableCustom ? 260 : 224);
      if (dataSource.length === 0 && queryEmptyPlaceHolder) {
        _dropdownHeight = 72;
      }
      var _py = rect[1] - _dropdownHeight - padding;
      setPosition([rect[0], _py]);
    }
    return dataSource;
  }, [fuzzyQuery, inputValue, dataSource, onQuery, rect, queryEmptyPlaceHolder, rflip, enableCustom, padding]);
  var onChange = useCallback(value => {
    var _dataSource$filter;
    setInputValue('');
    onSave === null || onSave === void 0 ? void 0 : onSave(value, false, (_dataSource$filter = _filterInstanceProperty(dataSource).call(dataSource, item => item.id === value)) === null || _dataSource$filter === void 0 ? void 0 : _dataSource$filter[0]);
  }, [dataSource, onSave]);
  var handleClick = e => {
    e.stopPropagation();
    var rect = e.currentTarget.getBoundingClientRect();
    var clientHeight = document.body.clientHeight;
    var px = rect.x || rect.left;
    var py = (rect.y || rect.top) + rect.height + padding;
    setrect([px, rect.y || rect.top, rect.width, rect.height]);
    var dropdownHeight = enableCustom ? Math.min((filteredOptions.length + 1) * 36, 260) : Math.min(filteredOptions.length * 36, 224);
    if (clientHeight <= py + dropdownHeight) {
      py = (rect.y || rect.top) - dropdownHeight - padding;
      setrflip(flip);
    } else {
      setrflip(false);
    }
    setPosition([px, py]);
    setIsOpen(!isOpen);
  };
  React.useEffect(() => {
    if (isOpen === false && inputValue !== null && inputValue !== void 0 && inputValue.length) {
      setInputValue('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  var input = useMemo(() => {
    if (enableCustom) {
      return /*#__PURE__*/React.createElement("div", {
        className: "sk-select-custom-dropdown-input"
      }, /*#__PURE__*/React.createElement(Input, {
        ref: input => {
          if (input) {
            input.focus();
          }
        },
        value: inputValue,
        suffix: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          onClick: e => {
            e.stopPropagation();
            setInputValue('');
          }
        }, inputValue.length > 0 && /*#__PURE__*/React.createElement(CloseIcon, {
          style: {
            width: '15px',
            height: '15px'
          }
        })), /*#__PURE__*/React.createElement("div", {
          onClick: e => {
            e.stopPropagation();
            if (_findInstanceProperty(dataSource).call(dataSource, item => item.value === inputValue)) {
              var _dataSource$filter2;
              onSave === null || onSave === void 0 ? void 0 : onSave(inputValue, false, (_dataSource$filter2 = _filterInstanceProperty(dataSource).call(dataSource, item => item.id === inputValue)) === null || _dataSource$filter2 === void 0 ? void 0 : _dataSource$filter2[0]);
            } else {
              onSave === null || onSave === void 0 ? void 0 : onSave(inputValue, true);
            }
            setIsOpen(false);
            setInputValue('');
          }
        }, /*#__PURE__*/React.createElement(CheckIcon, null))),
        placeholder: locale.inputPlaceHolder,
        onChange: e => {
          e.stopPropagation();
          setInputValue(e.target.value);
        },
        onClick: e => {
          e.stopPropagation();
        },
        onPressEnter: e => {
          e.stopPropagation(); // onPressEnter: conflict with antd default key setting
          if (_findInstanceProperty(dataSource).call(dataSource, item => item.value === inputValue)) {
            var _dataSource$filter3;
            // 如果当前input的值与列表相同做选择操作
            onSave === null || onSave === void 0 ? void 0 : onSave(inputValue, false, (_dataSource$filter3 = _filterInstanceProperty(dataSource).call(dataSource, item => item.id === inputValue)) === null || _dataSource$filter3 === void 0 ? void 0 : _dataSource$filter3[0]);
          } else {
            onSave === null || onSave === void 0 ? void 0 : onSave(inputValue, true);
          }
          setIsOpen(false);
          setInputValue('');
        }
      }));
    }
    return null;
  }, [enableCustom, inputValue, dataSource]);
  var dropDownView = useMemo(() => {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%'
      },
      onClick: handleClick
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('sk-select-custom-dropdown-container', {
        'sk-select-custom-dropdown-flip': rflip
      }),
      style: {
        left: position[0],
        top: position[1]
      }
    }, input, /*#__PURE__*/React.createElement("div", {
      className: "sk-select-custom-dropdown-wrapper"
    }, _mapInstanceProperty(filteredOptions).call(filteredOptions, item => {
      var selected = item.value === value;
      if (inputValue && !_findInstanceProperty(filteredOptions).call(filteredOptions, item => item.value === value)) {
        var _filteredOptions$;
        selected = item.value === ((_filteredOptions$ = filteredOptions[0]) === null || _filteredOptions$ === void 0 ? void 0 : _filteredOptions$.value);
      }
      return /*#__PURE__*/React.createElement("div", {
        key: item.id || item.value,
        className: cx('sk-select-custom-dropdown-item', {
          'sk-select-custom-dropdown-item-selected': selected
        }),
        "data-value": item.value,
        onClick: () => {
          onChange(item.value);
        }
      }, /*#__PURE__*/React.createElement("span", null, item.value));
    }), filteredOptions.length === 0 && queryEmptyPlaceHolder && /*#__PURE__*/React.createElement("div", {
      className: "sk-select-custom-dropdown-placeholder"
    }, queryEmptyPlaceHolder))));
  }, [input, filteredOptions, handleClick, rflip, inputValue, position]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('sk-select-custom', {
      'sk-select-custom-open': isOpen
    }),
    onClick: handleClick
  }, value, /*#__PURE__*/React.createElement(_ListDownIcon, null), isOpen && /*#__PURE__*/createPortal(dropDownView, document.querySelector('body')));
});
var CustomSelectWithConsumer = /*#__PURE__*/React.memo(props => /*#__PURE__*/React.createElement(ConfigConsumer, null, context => {
  var _context$locale;
  // @ts-ignore
  return /*#__PURE__*/React.createElement(CustomSelect, _extends({}, props, {
    locale: ((_context$locale = context.locale) === null || _context$locale === void 0 ? void 0 : _context$locale.Common) || zhCN
  }));
}));
export default CustomSelectWithConsumer;